import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import * as types from 'constants/actionTypes';

class SelectInputQueuedOrderPrepare extends Component {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.defaultValue || props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };

        this.onChange = this.onChange.bind(this);
    }

    componentWillMount() {
        if (!this.state.value && this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
            const selectedValue = this.props.defaultValue;
            let item = this.props.options.filter((item) => item.value == selectedValue)[0];
            this.props.dispatch({ type: types.FORM_INPUT, value: selectedValue, name: this.props.name });
            this.props.dispatch({ type: types.FORM_INPUT, value: item.text, name: `${this.props.name}Text` });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        }

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onChange = (event) => {
        const selectedValue = event.target.value;
        this.setState({selectedValue});
        this.props.dispatch({ type: types.FORM_INPUT, value: selectedValue, name: this.props.name });

        const selectedItem = this.props.options.find(item => item.value === selectedValue);
        if (selectedItem) {
            this.props.dispatch({ type: types.FORM_INPUT, value: selectedItem, name: `${this.props.name}Text` });
        }
        if (this.props.updateProductToScanned) {
            this.props.updateProductToScanned(this.state.value, this.props.name);
        }
    }

    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        const value = this.state && this.state.value;
        //maybe fix here
        const { options, className, error, dispatch, defaultValue, updateProductToScanned, ...textProps } = { ...p };
        if (!p.options) return null;

        return (<div className={p.className || "form-group"}>

            <FormControl variant="standard" fullWidth error={e && (value === undefined || value === '' || value == null)}>
                <InputLabel>{textProps.label}</InputLabel>
                <Select
                    {...textProps}
                    value={value}
                    id="selectLot"
                    onChange={this.onChange}
                    label={textProps.label}
                >
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.text}
                        </MenuItem>
                    ))}
                </Select>
                {e && (value === undefined || value === '' || value == null) && (
                    <FormHelperText>{error}</FormHelperText>
                )}
            </FormControl>
        </div>);
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(SelectInputQueuedOrderPrepare);